
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.9 9.38c1.484-.847 2.328-2.388 2.328-4.274 0-1.894-.853-3.603-2.173-4.355C10.175.246 9.077 0 7.7 0H.525A.53.53 0 000 .536v.357a.53.53 0 00.525.536h.873V18.57H.525a.53.53 0 00-.525.536v.357A.53.53 0 00.525 20h7.423c.873 0 1.996-.052 2.953-.462C12.784 18.74 14 16.708 14 14.359c0-2.343-1.234-4.302-3.1-4.978zM2.89 1.439H7.7c1.091 0 1.912.185 2.51.566.935.6 1.472 1.72 1.472 3.074 0 2.211-1.412 3.697-3.513 3.697h-5.28V1.438zm5.059 17.125c.967 0 1.704-.116 2.255-.354 1.41-.58 2.25-1.998 2.25-3.793 0-2.514-1.656-4.204-4.12-4.204H2.89v8.35h5.06z","fill":"#262626"}})])
          )
        }
      }
    